import * as React from 'react';

import {Button} from 'shells/button/button';
import {ButtonMover} from 'shells/button-mover/button-mover';

import {AddToAudiencePopover} from '../../../core/audiences/add-to-audience-popover';

import styles from './audience-info.module.css';

type Props = {
    onSubmitCreateAudience: (audienceId: string) => Promise<any>;
    contactName: string;
};

export function AddToAudienceButton(props: Props) {
    const [showAudiencePopover, setShowAudiencePopover] = React.useState<boolean>(false);
    const addToAudienceButtonRef = React.useRef();

    return (
        <>
            <div className={styles['audience-info-outer-container']}>
                <div className={styles['audience-info-inner-container']}>
                    <ButtonMover direction='right' size='normal'>
                        <Button
                            variant='text-primary'
                            onClick={() => {
                                setShowAudiencePopover(true);
                            }}
                            getButtonRef={addToAudienceButtonRef}
                        >
                            Add to audience
                        </Button>
                    </ButtonMover>
                </div>
            </div>
            {showAudiencePopover ? (
                <AddToAudiencePopover
                    entityType='contacts'
                    anchor={addToAudienceButtonRef.current}
                    onCancel={() => setShowAudiencePopover(false)}
                    onSubmit={(input) => props.onSubmitCreateAudience(input.value)}
                    // @ts-expect-error
                    onSuccess={() => {
                        setShowAudiencePopover(false);
                    }}
                    selectedCount={1}
                    showConfirmationPage={false}
                    itemName={props.contactName}
                />
            ) : undefined}
        </>
    );
}
